// Footer component created
const Footer = () => {
	return (
		<footer>
			<p>Created by <a href="https://clementsung.com/" target="_blank" rel="noreferrer">Clement Sung</a></p>
		</footer>
	)
}

export default Footer;